import styled from 'styled-components';

export const ToolbarLayout = styled.div`
  display: flex;
  gap: 0.5rem;
  padding: 0.5rem;
`;
